/* Furnies Cart V1: open native Savor cart drawer from custom header/footer;
   add suggested designs using Shopify Ajax + native CartLinesUpdateEvent. */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const cartURL = () => window.Theme?.routes?.cart_url || '/cart';
const addURL = () => window.Theme?.routes?.cart_add_url || '/cart/add.js';

function updateCartCount(quantity) {
  const count = Number.isFinite(Number(quantity)) ? Math.max(0,Math.floor(Number(quantity))) : 0;
  const badge = document.querySelector('.fn-header__count');
  if (badge) {badge.textContent = String(count);badge.hidden = count === 0;}
  document.querySelectorAll('[data-furnies-cart-open]').forEach(trigger => {
    const current = trigger.getAttribute('aria-label');
    if (current && current.startsWith('View cart')) {
      trigger.setAttribute('aria-label','View cart, ' + count + ' items');
    }
  });
  document.querySelectorAll('.fn-mobile-cart-count').forEach(element => {
    element.textContent = '(' + count + ')';
  });
}

async function openDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) {window.location.assign(cartURL());return;}
  if (!customElements.get('theme-drawer')) await customElements.whenDefined('theme-drawer');
  if (typeof drawer.open === 'function') drawer.open();
  else window.location.assign(cartURL());
}

let pendingUpsell = false;
async function addUpsell(button) {
  if (pendingUpsell) return;
  const variantId = Number(button.dataset.variantId);
  if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
  const section = button.closest('.fn-cart-upsell');
  const feedback = section?.querySelector('[data-furnies-upsell-feedback]');
  pendingUpsell = true;
  button.disabled = true;
  const original = button.textContent;
  button.textContent = 'Adding...';
  if (feedback) {feedback.textContent = '';feedback.hidden = true;}
  try {
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(x => x.dataset.sectionId).filter(Boolean);
    if (!sectionIds.includes('cart-drawer-section')) sectionIds.push('cart-drawer-section');
    const response = await fetch(addURL(),{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({
        items:[{id:variantId,quantity:1}],
        sections:sectionIds.join(','),
        sections_url:window.location.pathname
      })
    });
    const payload = await response.json();
    if (!response.ok || payload.status || payload.errors) {
      throw new Error(payload.description || payload.message || 'Could not add this design. Please try again.');
    }
    const cartResponse = await fetch(cartURL() + '.js',{
      credentials:'same-origin',
      headers:{Accept:'application/json'},
      cache:'no-store'
    });
    if (!cartResponse.ok) throw new Error('Item added, but the cart could not refresh. Reopen the cart to check.');
    const cart = await cartResponse.json();
    document.dispatchEvent(new CartLinesUpdateEvent({
      action:'add',
      context:'cart',
      lines:[{merchandiseId:String(variantId),quantity:1}],
      promise:Promise.resolve({
        cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail:{
          sections:payload.sections,
          items:cart.items,
          itemCount:cart.item_count,
          didError:false,
          source:'furnies-cart-upsells'
        }
      })
    }));
    updateCartCount(cart.item_count);
  } catch(error) {
    if (feedback) {feedback.textContent=error?.message || 'Could not add to cart. Please try again.';feedback.hidden=false;}
  } finally {
    pendingUpsell = false;
    if (button.isConnected) {button.disabled=false;button.textContent=original;}
  }
}

document.addEventListener('click',event => {
  const target = event.target instanceof Element ? event.target : null;
  const trigger = target?.closest('[data-furnies-cart-open]');
  if (trigger) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!document.getElementById('cart-drawer')) return;
    event.preventDefault();
    void openDrawer();
    return;
  }
  const add = target?.closest('[data-furnies-upsell-add]');
  if (add instanceof HTMLButtonElement) {event.preventDefault();void addUpsell(add);}
});

document.addEventListener(StandardEvents.cartLinesUpdate,event => {
  event.promise?.then(({cart,detail}) => {
    const count = cart?.totalQuantity ?? detail?.itemCount;
    if (count !== undefined) updateCartCount(count);
  }).catch(() => {});
});

function syncOpenState() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  const expanded = drawer.hasAttribute('open');
  document.querySelectorAll('[data-furnies-cart-open]').forEach(trigger => {
    trigger.setAttribute('aria-expanded',String(expanded));
  });
}
function connectDrawerState() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  new MutationObserver(syncOpenState).observe(drawer,{attributes:true,attributeFilter:['open']});
  syncOpenState();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',connectDrawerState,{once:true});
else connectDrawerState();
